import { Section } from 'services/api/vehicle-sections/types';

type GroupedGrades = { poor: number; fair: number; good: number };

const getPercentage = (value: number, total: number) => {
  if (total === 0) return 0;
  return Math.round((value / total) * 100);
};

export const useParsedGrades = (sections: Section[]) => {
  const grades = sections.reduce(
    (acc, curr) => {
      if (!curr.grade) return acc;
      return { ...acc, [curr.grade]: acc[curr.grade] + 1 };
    },
    {
      poor: 0,
      fair: 0,
      good: 0
    } as GroupedGrades
  );

  const total = grades.good + grades.fair + grades.poor;

  const orderedPercents = [
    { type: 'good', value: getPercentage(grades.good, total) },
    { type: 'fair', value: getPercentage(grades.fair, total) },
    { type: 'poor', value: getPercentage(grades.poor, total) }
  ].filter(e => e.value !== 0);

  return orderedPercents;
};
